import { Link } from "react-router-dom";
import { ShieldCheck, Github, Twitter, Mail } from "lucide-react";

const cols = [
  {
    title: "Product",
    links: [
      { to: "/features", label: "Features" },
      { to: "/security", label: "Security" },
      { to: "/pricing", label: "Pricing" },
      { to: "/download", label: "Download" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/contact", label: "Contact" },
      { to: "/faq", label: "FAQ" },
      { to: "/privacy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/security", label: "Whitepaper" },
      { to: "/security", label: "Audit-ready" },
      { to: "/faq", label: "Help Center" },
      { to: "/contact", label: "Report a bug" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      className="relative mt-24 bg-ink text-mint-50 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="absolute -top-40 -left-40 h-[420px] w-[420px] rounded-full mint-glow opacity-40 pointer-events-none" />
      <div className="absolute -bottom-40 -right-40 h-[520px] w-[520px] rounded-full mint-glow opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 pt-24 pb-10">
        <div className="mb-16">
          <p className="label-eyebrow text-mint-300/80 mb-6">Get in touch</p>
          <h2 className="font-heading font-bold leading-[0.9] tracking-tighter text-[14vw] sm:text-[10vw] lg:text-[7.5vw] text-mint-50">
            Let&apos;s talk.
          </h2>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-mint px-7 py-3.5 font-semibold text-ink hover:translate-y-[-2px] transition-transform"
            data-testid="footer-cta-contact"
          >
            Contact us →
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pt-10 border-t border-white/10">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-mint text-ink">
                <ShieldCheck className="h-5 w-5" />
              </span>
              <span className="font-heading font-bold text-xl">AVault</span>
            </div>
            <p className="mt-4 text-sm text-mint-50/70 max-w-sm leading-relaxed">
              Offline-first password & secrets vault. Your data stays on your
              device — encrypted with AES-256-GCM, locked behind a master
              password only you know.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="#"
                aria-label="GitHub"
                className="h-9 w-9 rounded-full inline-flex items-center justify-center bg-white/5 hover:bg-white/10 transition"
                data-testid="social-github"
              >
                <Github className="h-4 w-4" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="h-9 w-9 rounded-full inline-flex items-center justify-center bg-white/5 hover:bg-white/10 transition"
                data-testid="social-twitter"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a
                href="mailto:hello@avault.app"
                aria-label="Email"
                className="h-9 w-9 rounded-full inline-flex items-center justify-center bg-white/5 hover:bg-white/10 transition"
                data-testid="social-email"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <p className="label-eyebrow text-mint-300/80 mb-4">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-mint-50/80 hover:text-mint transition"
                      data-testid={`footer-link-${l.label
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-mint-50/50">
            © {new Date().getFullYear()} AVault. Crafted for the privacy-minded.
          </p>
          <p className="text-xs text-mint-50/50">
            AES-256-GCM · Argon2id · Zero-Knowledge
          </p>
        </div>
      </div>
    </footer>
  );
}
